import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ButtonColors,
  ConfirmDialogModel,
  DialogType,
  DialogVariant,
} from '@shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-reject-dialog',
  templateUrl: './reject-dialog.component.html',
  styleUrls: ['./reject-dialog.component.scss'],
})
export class RejectDialogComponent {
  title: string;
  message: string;
  variant: DialogVariant;
  dialogVariant = DialogVariant;
  dialogType = DialogType;
  type: DialogType;
  confirmColor: ButtonColors = ButtonColors.primary;
  cancelColor: ButtonColors = ButtonColors.accent;

  rejectForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RejectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel
  ) {
    this.title = data.title;
    this.message = data.message;
    this.variant = data.variant;
    this.type = data.dialogType;
    this.confirmColor = data.confirmColor;
    this.cancelColor = data.cancelColor;

    this.rejectForm = this.fb.group({
      reason: ['', [Validators.required]],
    });
  }

  onConfirm(): void {
    if (this.rejectForm.invalid) {
      this.rejectForm.markAllAsTouched();
      return;
    }
    this.dialogRef.close({
      isConfirmed: true,
      rejectReason: this.rejectForm.get('reason')?.value,
    });
  }

  onDismiss(): void {
    this.dialogRef.close({
      isConfirmed: false,
    });
  }
}
